import { useState, useEffect } from "react";

interface Tax {
  ID: number;
  name: string;
  taux: number;
}

interface UseTaxesOptions {
  companyId?: number | null;
}

export const useTaxes = (api: any, options: UseTaxesOptions = {}) => {
  const [taxes, setTaxes] = useState<Tax[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { companyId } = options;

  useEffect(() => {
    const loadTaxes = async () => {
      if (!companyId) {
        setTaxes([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await api.fetchTaxes(companyId);
        setTaxes(response); // La réponse est déjà le tableau de taxes
      } catch (err) {
        setError("Erreur lors du chargement des taxes");
        console.error("Erreur taxes:", err);
      } finally {
        setLoading(false);
      }
    };

    loadTaxes();
  }, [api, companyId]);

  return { taxes, loading, error };
};

export default useTaxes;
